import _ from 'lodash';
import React, { Fragment } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import { FieldFactory } from 'client/shared/components';
import PasswordInfo from './password-info';
import AgeInfo from './age-info';
import GenderSelect from 'client/shared/components/add-band-modal/gender-select';
import FIELD_KEY_MAP from './field-key-map';
import ReactHintFactory from 'react-hint'
const ReactHint = ReactHintFactory(React);

@inject('formStore', 'userStore')
@observer
export default class AccountCreationForm
extends React.Component {
	constructor (props) {
		super(props);

		const { userStore, formStore, user } = this.props;

		if (_.isEmpty(userStore.newFBUserData) !== true) {

			const { profileImage } = userStore.newFBUserData;
			user.update({ profileImage });
			formStore.validation.profileImage = true;
		}

	}

	render () {
		const { user, formStore, userStore } = this.props;
		const sharedFieldProps = {
			noFieldClass: true,
			item: user,
			store: userStore,
			formStore,
			onChange: this.onChange,
		};
		return (
			<div>
				<div className="grid-x grid-padding-x" style={{height:'100vh'}}>
					<div className="grid-x align-middle" style={{justifyContent:"center", background:"transparent", width:"100%", flexDirection:"column"}}>
						<div className="logo"></div>
						<div className="admin-title">Fan Sign Up</div>
					</div>

					<div className="align-spaced row artist-cms main-sign-up artist-sign-up cell small-12 padding-bottom-0" style={{ backgroundColor:'transparent', color: '#fff' }}>
						<div>
							<div className="grid-x padding-horizontal-1 margin-top-2">
								<ReactHint events={ { hover: true } } position="right" onRenderContent={(e) => this.renderPasswordReq(e)} persist />
								<div className="cell small-6" style={{display: "flex", flexDirection: "column"}}>
									<div className="grid-x grid-padding-x">
										<div className="cell small-6">
											<FieldFactory
												{ ...sharedFieldProps }
												fieldKey={ FIELD_KEY_MAP.firstName }
												placeholder='First Name'
												label='First Name'
											/>
										</div>
									</div>
									<div className="grid-x grid-padding-x">
										<div className="cell small-6">
											<FieldFactory
												{ ...sharedFieldProps }
												fieldKey={ FIELD_KEY_MAP.lastName }
												placeholder='Last Name'
												label='Last Name'
											/>
										</div>
									</div>

									<div style={{position:"relative"}}>
										<div className="grid-x align-middle" data-ta={ FIELD_KEY_MAP.dob }>
										<FieldFactory
											{ ...sharedFieldProps }
											fieldKey={ FIELD_KEY_MAP.dob }
											validate={ this.validateAge }
											placeholder='Birthday (MM/DD/YYYY)'
											label='Birthday'
										/>
										</div>
										<AgeInfo user={user}/>
									</div>
									<GenderSelect user={user} onChange={(gender)=>{this.onChange(FIELD_KEY_MAP.gender, gender)}} />
								</div>
								<div className="cell small-6" style={{display: "flex", flexDirection: "column"}}>
									<div className="grid-x grid-padding-x">
										<div className="cell small-6">
										<FieldFactory
											{ ...sharedFieldProps }
											fieldKey={ FIELD_KEY_MAP.email }
											placeholder='Email'
											label='Email'
										/>
										</div>
									</div>

									<div style={{position:"relative", maxWidth:"18vw"}}>
										<div className="grid-x align-middle">
											<FieldFactory
												noFieldClass
												item={ user }
												store={ userStore }
												formStore={ formStore }
												onChange={ this.onChange }
												fieldKey={ FIELD_KEY_MAP.password }
												placeholder='Password'
												changeOnBlur={false}
												changeOnKeyUp={true}
												label='Password'
											/>
										<PasswordInfo isPasswordBox={true} />
										</div>
									</div>
									<div style={{position:"relative", maxWidth:"18vw"}}>
										<div className="grid-x align-middle">
											<FieldFactory
												noFieldClass
												item={ user }
												store={ userStore }
												formStore={ formStore }
												onChange={ this.onChange }
												fieldKey={ FIELD_KEY_MAP.confirmPassword }
												changeOnBlur={false}
												changeOnKeyUp={true}
												validate={ this.validateConfirmPassword }
												placeholder='Confirm Password'
												label='Confirm Password'
											/>
										<PasswordInfo isPasswordBox={false} />
										</div>
									</div>
								</div>
							</div>
							<div className="grid-x grid-padding-x">
									<div className="cell row align-center small-12">
										<button
											type="button hollow"
											data-ta="saveAddMemberModalBtn"
											className="button neo mdl"
											onClick={ this.onSubmitClick }
											disabled={ this.submitDisabled() }
										>
											Sign Up
										</button>
									</div>
								</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderPasswordReq (e) {
		let defaultRh = e.getAttribute('data-rh')

		if(defaultRh.length > 0) {
			return (
				<div style={{width:'25vw',
					textAlign:'left', 
					boxShadow:`6px 6px 13px -3px #000000`, padding: '0.5vw',
					backgroundColor: "#381648"}}>
					{defaultRh}
				</div>
			)
		}
		return (
			<div style={{width:'25vw',
				textAlign:'left', 
				boxShadow:`6px 6px 13px -3px #000000`, padding: '0.5vw',
				backgroundColor: "#381648"}}>
				Your password must:<br/>
				<ul style={{listStyleType:'none'}}>
					<li>Be at least 8 characters long</li>
					<li>Contain at least one uppercase letter</li>
					<li>Contain at least one number</li>
					<li>Contain at least one special character</li>
					<li>Not contain sequences of three or more repeated characters</li>
				</ul>
			</div>
		)

	}

	submitDisabled () {
		const {
			formStore: {
				validation: {
					// profileImage = false,
					accountCreationForm = false
				}
			}
		} = this.props;

		const submitDisabled =
			// profileImage !== true ||
			accountCreationForm !== true;

		return submitDisabled;
	}

	@autobind
	validateAge (value) {
		const { formStore } = this.props;
		return formStore.validate(value, FIELD_KEY_MAP.dob);
	}

	@autobind
	validateConfirmPassword (confirmPassword, key) {
		const { formStore, user: { password } } = this.props;
		const value = {
			password,
			confirmPassword
		};

		return formStore.validate(value, key);
	}

	@autobind
	onChange (key, value) {
		const { props, user, artist, formStore } = this.props;
		const isValid = formStore.validateFields(_.values(FIELD_KEY_MAP), (key) => {
			const item = (/^user/).test(key) ? user : artist;
			const value = item[key.replace(/^.+\./, '')];
			if (key === FIELD_KEY_MAP.confirmPassword) {

				return {
					confirmPassword: value,
					password: user.password
				};
			}

			return value;
		});

		formStore.validation = {
			accountCreationForm: isValid
		};

		if (key === FIELD_KEY_MAP.dob) {
			user.dob = value;
		}

		if (key === FIELD_KEY_MAP.email) {

			user.userName = value;
		}
		if (key === FIELD_KEY_MAP.gender) {
			user.gender = value;
		}
	}

	@autobind
	onKeyPress ({ key }) {
		const isEnterKey = (/enter/i).test(key);
		if (isEnterKey && this.submitDisabled() !== true) {

			this.onSubmitClick();
		}
	}

	@autobind
	async onSubmitClick () {
		await this.saveProfile();

		if (this.props.disableAutoLogin) {

			this.pullDataAndCloseModal();
			return;
		}

		this.props.afterSubmit();
	}

	async saveProfile () {
		const { user } = this.props;

		this.setState({
			savingMessage: 'Saving profile...'
		});

		//This is a hack, need to find out why this.user has its state cleared after save 
		this.userData = user.serialized;

		await this.props.userStore.saveUser(user);
	}

	pullDataAndCloseModal () {
		const { userStore } = this.props;

		userStore.fetch();
	}
}

